import '../Scss/app.scss';

// Components
import events from './helpers/events';
import general from './core/general';
import header from './core/header';
import search from './components/search';
const modules = [general, events, header, search];
modules.forEach(module => {
  module();
});
const components = [{
  el: '.accordion-item',
  fileName: 'components/accordion'
}, {
  el: '.cards-group',
  fileName: 'components/cards-group'
}, {
  el: '.carousel',
  fileName: 'components/carousel'
}, {
  el: '.menu-pages',
  fileName: 'components/menu-pages'
}, {
  el: '.tx-powermail',
  fileName: 'components/powermail'
}, {
  el: '.video',
  fileName: 'components/video'
}, {
  el: '.icons-group--lg',
  fileName: 'components/icons-group'
}, {
  el: '.locations-search',
  fileName: 'extensions/locations/locations'
}];
const componentImport = async (el, fileName) => {
  if (!document.querySelector(el)) return;
  const module = await import(`./${fileName}`);
  // Initialize module
  if (typeof module === 'function') {
    module();
  } else if (typeof module === 'object' && typeof module.default === 'function') {
    module.default();
  }
};
components.forEach(component => {
  const {
    el,
    fileName
  } = component;
  componentImport(el, fileName);
});